// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"045ebebf","921":"d40fff59"}[chunkId] + ".chunk.js";
};